import { mutate } from 'swr'
import { post } from '@api/apiFetcher'
import mutateUser from '@utils/user/mutateUser'
import { clearGuest } from 'lib/watch/guestWatch'

const SESSION_TIMEOUT_KEY = 'session_timeout'
const SAFETY_MARGIN = 5 * 60 * 1000

const clearSchedule = () => {
    clearTimeout(global[SESSION_TIMEOUT_KEY])
    global[SESSION_TIMEOUT_KEY] = null
}

const setSchedule = (func, time) => {
    clearSchedule()
    global[SESSION_TIMEOUT_KEY] = setTimeout(func, time)
}

const destroySession = () => {
    clearSchedule()
    window.localStorage.removeItem('user')
    clearGuest()
    mutate('user', null)
}

const scheduleDestroySession = (tokenPayload) => {
    const time = tokenPayload.expires - Date.now()
    setSchedule(destroySession, time)
}

const renewSession = (user) => {
    post({ path: '/api/user/refresh_token', auth: user?.token })
        .then(res => {
            if (res.success) {
                mutateUser(user, res.user) // <- other than mutate from swr imported above
            } else {
                destroySession()
            }
        })
        .catch(err => null)
}

// Nowy token (np. po zmianie hasła) — odświeżenie planowane od nowa, bez starego tokenu w zamknięciu.
const scheduleRenewSession = (user, expiryTime) => {
    if (global[SESSION_TIMEOUT_KEY] == null || global[SESSION_TIMEOUT_KEY + '_token'] !== user?.token) {
        const time = expiryTime - Date.now() - SAFETY_MARGIN
        setSchedule(() => renewSession(user), time)
        global[SESSION_TIMEOUT_KEY + '_token'] = user?.token
    }
}

export {
    SESSION_TIMEOUT_KEY,
    destroySession,
    scheduleDestroySession,
    renewSession,
    scheduleRenewSession,
}